import { useEffect, useState } from 'react';
import { getRoutes, hasRoute } from '../../utils/getRoutes';
import { Redirect, Route } from 'react-router-dom';
import { PageNotFound } from '../../pages/PageNotFound';

export const Routes = () => {
    const [ isMounted, setIsMounted ] = useState(false);
    const [ routes, setRoutes ] = useState([]);
    const [ mainPageLink, setMainPageLink ] = useState('');
    useEffect(() => {
        (async () => {
            const { availableRoutes, mainPageLink } = await getRoutes();
            setRoutes(availableRoutes);
            setMainPageLink(mainPageLink);
            setIsMounted(true);
        })();
    }, []);
    if (!isMounted && !mainPageLink) return null;
    if (!hasRoute()) return <PageNotFound />;
    return (
        <>
            <Route
                exact
                path='/'
            >
                <Redirect to={mainPageLink} />
            </Route>
            {
                routes.map(({ link, component }) => (
                    <Route
                        key={link}
                        exact
                        path={link}
                    >
                        {component}
                    </Route>
                ))
            }
            <Route path='*'>
                <Redirect to={mainPageLink} />
            </Route>
        </>
    );
};
